function lookbook() {
  const lookbook = document.querySelector('.tp-lookbook')
  if (!lookbook) return;

  var lookbookSlide = new Swiper(".js-lookbook-prd__active", {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-next-lookbook",
      prevEl: ".swiper-prev-lookbook"
    },
    pagination: {
      clickable: true,
      el: ".swiper-pagination-lookbook",
    },
  });

  document.addEventListener('click', function (e) {
    const target = e.target.closest('.lookbook-pin');
    if (!target) return;

    e.preventDefault();

    const parent = target.closest('.tp-lookbook__item');
    const allPins = parent.querySelectorAll('.lookbook-pin');

    if (target.classList.contains('active')) {
      return;
    }

    allPins.forEach(pin => pin.classList.remove('active'));

    target.classList.add('active');

    let initIndexSlide = target.dataset.active || 0;
    lookbookSlide.slideTo((parseInt(initIndexSlide) + 1), 0, false);
  });

  if (innerWidth < 1023) {
    const lookbookActive = document.querySelector('.lookbook-pin.active');
    if (lookbookActive) {
      lookbookActive.classList.remove('active');
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.lookbook-pin')) {
        const lookbookActive = document.querySelector('.lookbook-pin.active');
        if (lookbookActive) {
          lookbookActive.classList.remove('active');
        }
      }
    });
  }
}

lookbook();

document.addEventListener("shopify:section:load", lookbook);
document.addEventListener("shopify:section:unload", lookbook);